import React, { useEffect, Fragment, useState } from "react";
import { Row, Col } from "reactstrap";
import { MODULE_API } from "../../../../apis";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Loader from "../../../../components/styled-components/loader/loader";
import { SelectionSkeleton } from "../../../../newComponents/Skeletons/SelectionSkeleton";
import "./styles/liabilitySelect.css";
const AssetAllocationLiabilites = () => {
  const [data, setData] = useState();
  const [loading, setIsLoading] = useState(true);
  const history = useHistory();
  const [liabalities, setLiabilies] = useState([]);
  const [credits, setCredits] = useState([]);

  async function getAllAssets() {
    setIsLoading(true);
    let data = await MODULE_API.insuraceAllocation("Liabilities and Credit");
    if (data && data.liability) {
      setLiabilies(data.liability);
    }
    if (data && data.credit) {
      setCredits(data.credit);
    }
    setIsLoading(false);
  }

  function handleAssetSelect(name) {
    history.push(`/liabilities_credit_new/${name}`);
  }
  useEffect(() => {
    getAllAssets();
  }, []);

  return (
    <Fragment>
      <div className="info-form-block">
        <Row gutter={16}>
          <Col span={24}>
            <h2 className="text-center font-weight-bold mb-4">
              Select the Type of Liability
            </h2>
          </Col>
        </Row>
      </div>

      <div className="selelctmain">
        <h3 className="selectHeading">Liabilities</h3>
        {loading && <SelectionSkeleton count={5} />}
        <div className="selectmain" style={{ justifyContent: "flex-start" }}>
          {liabalities &&
            liabalities.map((item, index) => (
              <div
                key={index}
                onClick={() => handleAssetSelect(item.name)}
                className="selectMaincards"
              >
                <div className="selectMaincardsInner">
                  {" "}
                  <div className="selectMainImages">
                    <img src={item.image} height={"40px"} alt={item.name} />{" "}
                  </div>
                  <div className="selectMainHeader">
                    <span className="selectheadingValue">
                      {item.name === "Real Estates" ? "Real Estate" : item.name}
                    </span>
                  </div>
                </div>
              </div>
            ))}
        </div>
        <h3 className="selectHeading" style={{ marginTop: "1rem" }}>
          Credit
        </h3>
        {loading && <SelectionSkeleton count={3} />}
        <div className="selectmain" style={{ justifyContent: "flex-start" }}>
          {credits &&
            credits.map((item, index) => (
              <div
                key={index}
                onClick={() => handleAssetSelect(item.name)}
                className="selectMaincards"
              >
                <div className="selectMaincardsInner">
                  {" "}
                  <div className="selectMainImages">
                    <img src={item.image} height={"40px"} alt={item.name} />{" "}
                  </div>
                  <div className="selectMainHeader">
                    <span className="selectheadingValue">{item.name}</span>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </Fragment>
  );
};

export default AssetAllocationLiabilites;
